import { CourseContentType, FeedbackQuestionTypeEnum } from '@/types/schema';

class CourseEntity {
  static id = (course: CourseContentType) => course.id ?? '';
  // Static property 'name' conflicts with built-in property 'Function.name' :(
  static getName = (course: CourseContentType) => course.name ?? '';

  static rootBlockId = (course: CourseContentType) =>
    (course as CourseContentType & { requestedRootBlockId?: string })?.requestedRootBlockId ??
    course.rootBlockId!;

  static defaultGroupId = (course: CourseContentType) => course.defaultGroupId ?? '';

  static userPermissions = (course: CourseContentType) => course.userPermissions ?? [];
  static sharedSpace = (course: CourseContentType) => course.sharedSpace ?? [];
  static applicableRoles = (course: CourseContentType) => course.applicableRoles ?? [];

  static status = (course: CourseContentType) => course.performance?.status;

  static lessonFeedbackQuestions = (course?: CourseContentType) =>
    course?.feedbackQuestions?.filter(
      (question) => question.type === FeedbackQuestionTypeEnum.LessonQuality,
    ) ?? [];

  static courseFeedbackQuestions = (course?: CourseContentType) =>
    course?.feedbackQuestions?.filter(
      (question) => question.type === FeedbackQuestionTypeEnum.CourseQuality,
    ) ?? [];
  static isReviewEnabled = (course: CourseContentType) => !!course.courseSettings?.isReviewEnabled;

  static cover = (course: CourseContentType) => course.cover;

  static commentChannelId = (course: CourseContentType) => course.creatorCommentChannelId;

  static certificateSettings = (course: CourseContentType) => course.certificateSettings;

  static certificateTemplate = (course: CourseContentType) => course.certificateTemplate;

  static issuedCertificate = (course: CourseContentType) => course.performance?.issuedCertificate;

  static userBadges = (course: CourseContentType) => course.performance?.userBadges;

  static points = (course: CourseContentType) => course.pointsConfig?.points;

  static dripSettings = (course: CourseContentType) => course.dripSettings;
}

export default CourseEntity;
